import PomodoroTimerComponent from '../../components/PomodoroTimer/PomodoroTimer';
import { useT } from '../../hooks/useT';
import styles from './PomodoroTimer.module.css';

function PomodoroTimerBlock({ titleKey, descKey }) {
  const t = useT();

  return (
    <div className={styles.section}>
      {titleKey && <h2 className={styles.title}>{t(titleKey)}</h2>}
      {descKey && <p className={styles.desc}>{t(descKey)}</p>}
      <PomodoroTimerComponent />
    </div>
  );
}

export default PomodoroTimerBlock;
